import { render, staticRenderFns } from "./deleteV2Icon.vue?vue&type=template&id=0e99a298&scoped=true&"
import script from "./deleteV2Icon.vue?vue&type=script&lang=js&"
export * from "./deleteV2Icon.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0e99a298",
  null
  ,true
)

export default component.exports